const footer = {
  copyright: 'Пегас Армс ТОВ. Всі права захищено.',
  terms: {
    text: `Заборонено копіювання, поширення та будь-яке інше використання матеріалів цього сайту без письмової згоди правовласника. 
    Використовуючи цей сайт, ви погоджуєтесь з `,
    and: ' та ',
    links: {
      terms: 'умовами використання',
      privacy: 'політикою конфіденційності.',
    },
  },
}

export default footer
